'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCalendarWeek, iconCalendarWeekTag } from '@ni/nimble-components/dist/esm/icons/calendar-week';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCalendarWeek };
export { iconCalendarWeekTag };
export const NimbleIconCalendarWeek = wrap(IconCalendarWeek);